class RestBanners {
  constructor(data) {
    this.bannerDes = data.bannerDes;
    this.date = data.date;
    this.dateTime = data.dateTime;
    this.imageUrl = data.imageURL || data.imageUrl;
    this.imageURL = this.imageUrl;
    this.restId = data.restId;
    this.restName = data.restName;
    this.time = data.time;
  }
}

export default RestBanners;
